import { Section } from '../layout/Section'
import { AlertTriangle, CheckCircle2 } from 'lucide-react'
import { differentials } from '../../data/differentials'

export function Challenge() {
    return (
        <Section id="desafio" background="dark">
            <div className="grid lg:grid-cols-2 gap-12 items-start">
                {/* The Problem */}
                <div>
                    <div className="flex items-center gap-3 mb-6">
                        <div className="w-12 h-12 rounded-full bg-orange-500/20 flex items-center justify-center">
                            <AlertTriangle className="w-6 h-6 text-orange-400" />
                        </div>
                        <h2 className="text-3xl font-bold">O Desafio Corporativo</h2>
                    </div>

                    <h3 className="text-xl font-semibold text-dpxp-secondary mb-4">
                        Do Legado à Transformação Digital
                    </h3>

                    <div className="space-y-4 text-gray-300 leading-relaxed mb-8">
                        <p>
                            Muitas organizações operam com soluções de gestão e sistemas legados. Ferramentas que, embora um dia eficientes, hoje lutam para atender às necessidades do mercado e não acompanham a velocidade das novas diretrizes de negócio.
                        </p>
                        <p>
                            Com a aceleração da transformação digital e novos investimentos, as empresas enfrentam uma pressão imensa para evoluir. O problema central? <strong className="text-white">Em muitos casos, a TI ainda está restrita à infraestrutura e atua de forma reativa.</strong>
                        </p>
                    </div>

                    {/* Illustration - Legacy Systems */}
                    <div className="flex justify-center">
                        <img
                            src="/assets/laptop-isometrico-perfil-usuario-dashboard-alinhado-esquerda.svg"
                            alt="Sistemas legados e dashboards"
                            className="w-full max-w-sm opacity-90"
                        />
                    </div>
                </div>

                {/* The Solution */}
                <div>
                    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="w-12 h-12 rounded-full bg-dpxp-accent/20 flex items-center justify-center">
                                <CheckCircle2 className="w-6 h-6 text-dpxp-accent" />
                            </div>
                            <h3 className="text-2xl font-bold text-dpxp-accent">A Resposta DPXP</h3>
                        </div>

                        <p className="text-gray-300 leading-relaxed mb-6">
                            Nossa expertise é reestruturar a área de tecnologia, preparando-a para suportar a complexidade de novas soluções e impulsionar a inovação. Convertemos processos ambíguos em uma base sólida para o futuro.
                        </p>

                        {/* Differentials - Renderização dinâmica */}
                        <div className="space-y-4 mb-8">
                            {differentials.map((diff) => {
                                const Icon = diff.icon
                                return (
                                    <div key={diff.id} className="flex items-center gap-3 bg-dpxp-primary/20 rounded-lg p-4 border border-dpxp-primary/30">
                                        <Icon className="w-8 h-8 text-dpxp-secondary flex-shrink-0" />
                                        <div>
                                            <span className="font-bold text-white">{diff.title}</span>
                                            <p className="text-sm text-gray-400">
                                                {diff.description}
                                            </p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                        {/* Illustration - DevOps/Audit */}
                        <div className="flex justify-center">
                            <img
                                src="/assets/lupa-auditoria-codigo-devops-banco-dados-backend-alinhado-direita.svg"
                                alt="Auditoria e DevOps"
                                className="w-full max-w-xs opacity-90"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}
